import { WatchPlanDay } from '../../utils/api/getWatchPlan';
import WatchPlanResources from './WatchPlanResources';
import styles from './styles.module.css';

interface Props {
  days: WatchPlanDay[];
  selectedDayId: string;
  onSelectDay: (dayId: string) => void;
  darkMode: boolean;
  isMobile: boolean;
  showResources?: boolean;
}

/**
 * Left panel (or mobile select) listing watch plan days in day_order.
 */
const WatchPlanDayList = ({
  days,
  selectedDayId,
  onSelectDay,
  darkMode,
  isMobile,
  showResources = true,
}: Props): JSX.Element => {
  if (isMobile) {
    return (
      <div className={`${styles.dayList} ${styles.dayListMobile}`}>
        <select
          className={`${styles.daySelect} ${darkMode && styles.daySelectDarkMode}`}
          value={selectedDayId}
          onChange={event => onSelectDay(event.target.value)}
          aria-label="Select a plan day"
        >
          {days.map(day => (
            <option key={day.id} value={day.id}>
              {`Day ${day.day_order}: ${day.day_description}`}
            </option>
          ))}
        </select>
        {showResources && <WatchPlanResources darkMode={darkMode} />}
      </div>
    );
  }

  return (
    <div className={styles.dayList}>
      <div className={styles.dayListItems}>
        {days.map(day => {
          const isSelected = day.id === selectedDayId;
          const itemClass = `${styles.dayItem} ${darkMode && styles.dayItemDarkMode} ${
            isSelected && styles.dayItemSelected
          }`;

          return (
            <button
              key={day.id}
              type="button"
              className={itemClass}
              onClick={() => onSelectDay(day.id)}
              aria-current={isSelected ? 'true' : undefined}
            >
              <span className={styles.dayOrder}>{`Day ${day.day_order}`}</span>
              <span className={styles.dayDescription}>{day.day_description}</span>
            </button>
          );
        })}
      </div>
      {showResources && <WatchPlanResources darkMode={darkMode} />}
    </div>
  );
};

export default WatchPlanDayList;
